import ResolutionButton from 'app/components/checkout/steps/partials/ResolutionButton'

export default class NextButton extends ResolutionButton {
  get className () {
    return 'next-step'
  }

  get arrow () {
    return <span className='arrow arrow-right' />
  }
}
